export type BucketBarChartPoint = {
  label: string;
  value: number;
};

export function BucketBarChart({
  ariaLabel,
  data,
  formatValue,
}: {
  ariaLabel: string;
  data: BucketBarChartPoint[];
  formatValue: (value: number) => string;
}) {
  const width = 720;
  const height = 230;
  const left = 12;
  const right = 12;
  const top = 12;
  const bottom = 42;
  const plotWidth = width - left - right;
  const plotHeight = height - top - bottom;
  const maximum = Math.max(1, ...data.map((point) => point.value));
  const slotWidth = plotWidth / Math.max(1, data.length);
  const barWidth = Math.min(38, slotWidth * 0.56);

  return (
    <figure className="ui-bucket-bar-chart">
      <svg viewBox={`0 0 ${width} ${height}`} role="img" aria-label={ariaLabel}>
        <line
          className="ui-bucket-bar-baseline"
          x1={left}
          x2={width - right}
          y1={top + plotHeight}
          y2={top + plotHeight}
        />
        {data.map((point, index) => {
          const barHeight = (point.value / maximum) * plotHeight;
          const center = left + slotWidth * index + slotWidth / 2;

          return (
            <g key={`${point.label}:${index}`}>
              <rect
                className="ui-bucket-bar"
                x={center - barWidth / 2}
                y={top + plotHeight - barHeight}
                width={barWidth}
                height={barHeight}
                rx="4"
              >
                <title>
                  {point.label}: {formatValue(point.value)}
                </title>
              </rect>
              <text
                className="ui-bucket-bar-label"
                x={center}
                y={height - 14}
                textAnchor="middle"
              >
                {point.label}
              </text>
            </g>
          );
        })}
      </svg>
      <ul className="ui-visually-hidden">
        {data.map((point, index) => (
          <li key={`${point.label}:${index}`}>
            {point.label}: {formatValue(point.value)}
          </li>
        ))}
      </ul>
    </figure>
  );
}
